import axios, { AxiosError, AxiosResponse } from 'axios';
import { GetFileUriProps } from '../../../src/controllers/apis/microsoft/storage';

export interface UtilsGetImageWithUriProps {
  fileUri: string;
  opts?: {
    onError?: (err: AxiosError) => void;
    onSuccess?: (res: AxiosResponse) => void;
  };
}
export default function getImageWithUri ({
  fileUri,
  opts,
}: UtilsGetImageWithUriProps) {
  const data: GetFileUriProps = {
      fileUri,
  };
  axios
    .post('/get_file_with_uri/', data)
    .catch((err: AxiosError) => {
      if (opts.onError && typeof(opts.onError) === 'function') {
        opts.onError(err);
      }
    })
    .then((res: AxiosResponse) => {
      if (opts.onSuccess && typeof(opts.onSuccess) === 'function') {
        opts.onSuccess(res);
      }
    });
}
